var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.id || _vm.def)?_c('img',{staticClass:"header-image",attrs:{"src":_vm.$store.$global.fileTarget +
    _vm.stringToHex(_vm.id) +
    '.jpg' +
    (_vm.$store.$global.upUpdateTime && _vm.$store.$storeUser.isLogin() && _vm.id == _vm.$store.$storeUser.UserInfo.id
      ? `?avatar=${_vm.$store.$global.upUpdateTime}`
      : ''),"alt":_vm.nickname,"size":_vm.size},on:{"click":_vm.onclick}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }